// @ts-ignore
import { METRIC_TYPE } from "../../constants";

type SupplementItem = {
  INDEX: number;
  TITLE: string;
  TEXT: string;
};

type GNCSupplementData = {
  INDEX: number;
  TITLE: string;
  IMPROVE_AREAS: SupplementItem[];
};

// Keyed by METRIC_TYPE
export const GNC_SUPPLEMENTS_DATA: Record<number, GNCSupplementData> = {
  [METRIC_TYPE.SDNN]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Ashwaganda",
        TEXT: "Helps balance stress hormones to support calmer energy, better mood, and faster recovery.",
      },
      {
        INDEX: 2,
        TITLE: "Nootropic / Brain Formula",
        TEXT: "Supports nerve signaling and stress resilience so your nervous system can shift between alert and calm.",
      },
      {
        INDEX: 3,
        TITLE: "Probiotic",
        TEXT: "Supports the gut-brain connection, which plays a key role in managing your body's stress response.",
      },
    ],
  },
  [METRIC_TYPE.VENTILATION_EFFICIENCY]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "NAC / Immune Advanced",
        TEXT: "May help keep airways clear and support your lungs' natural defenses for smoother breathing.",
      },
      {
        INDEX: 2,
        TITLE: "Turmeric",
        TEXT: "Helps reduce airway inflammation, supporting clearer breathing and more efficient oxygen exchange.",
      },
      {
        INDEX: 3,
        TITLE: "Nitric Oxide Booster",
        TEXT: "Arginine & Citrulline expand blood vessels so more oxygen reaches your lungs with every breath.",
      },
    ],
  },
  [METRIC_TYPE.BREATHING_STABILITY]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Magnesium Glycinate",
        TEXT: "Supports the nerve and muscle signals that keep your diaphragm and breathing muscles coordinated.",
      },
      {
        INDEX: 2,
        TITLE: "Ashwagandha",
        TEXT: "Reduces stress-driven shallow breathing, promoting a slower, more controlled breath pattern.",
      },
      {
        INDEX: 3,
        TITLE: "Multivitamin",
        TEXT: "B-complex and zinc support healthy nerve function and muscle coordination essential for steady breathing.",
      },
    ],
  },
  [METRIC_TYPE.LUNG_FITNESS]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Vitamin D3 + K2",
        TEXT: "Supports respiratory muscle strength and lung tissue health for fuller, deeper breaths.",
      },
      {
        INDEX: 2,
        TITLE: "Magnesium Glycinate",
        TEXT: "Relaxes airway smooth muscle and supports respiratory function so your lungs can fill to capacity.",
      },
      {
        INDEX: 3,
        TITLE: "CoQ10",
        TEXT: "Fuels the breathing muscles so your lungs can expand fully with every breath.",
      },
    ],
  },
  [METRIC_TYPE.HEART_FITNESS]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Fish Oil (Omega-3)",
        TEXT: "Supports heart rhythm health and helps the nervous system regulate heart rate for a better HRV score.",
      },
      {
        INDEX: 2,
        TITLE: "Hormone Booster",
        TEXT: "Supports healthy testosterone and cortisol balance — both directly linked to a stronger HRV score.",
      },
      {
        INDEX: 3,
        TITLE: "CoQ10",
        TEXT: "Supports heart energy production and healthy cardiac function tied to HRV.",
      },
    ],
  },
  [METRIC_TYPE.RMR]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Thermogenic",
        TEXT: "Helps raise the number of calories your body burns throughout the day.",
      },
      {
        INDEX: 2,
        TITLE: "Creatine + Hormone Booster",
        TEXT: "Creatine fuels cellular energy while Hormone Booster supports the hormonal environment needed for a healthy metabolism.",
      },
      {
        INDEX: 3,
        TITLE: "NAD+",
        TEXT: "Supports cellular energy production, helping your metabolism run at a higher and more efficient rate.",
      },
    ],
  },
  [METRIC_TYPE.FATBURN_EFFICIENCY]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Carnitine",
        TEXT: "Transports fat into your cells to be burned for energy instead of stored.",
      },
      {
        INDEX: 2,
        TITLE: "Omega / CLA",
        TEXT: "CLA + Omega activate your body's fat-burning pathways for more efficient use of fat as fuel.",
      },
      {
        INDEX: 3,
        TITLE: "Carb & Fat Blocker",
        TEXT: "Helps limit how much fat and carbs your body absorbs, so more stored fat gets used as fuel.",
      },
    ],
  },
  [METRIC_TYPE.METABOLIC_DYSFUNCTION_RISK]: {
    INDEX: 3,
    TITLE: "Supplements",
    IMPROVE_AREAS: [
      {
        INDEX: 1,
        TITLE: "Berberine",
        TEXT: "Supports your body's ability to shift between burning fat and carbs more efficiently.",
      },
      {
        INDEX: 2,
        TITLE: "Chromium + Cinnamon",
        TEXT: "Helps support healthy blood sugar balance, making it easier for your body to switch fuel sources.",
      },
      {
        INDEX: 3,
        TITLE: "Carnitine",
        TEXT: "Helps your body quickly access fat as fuel for a smoother switch between energy sources.",
      },
    ],
  },
};
